module.exports = __webpack_public_path__ + "static/media/alert-icon.260b1b39.svg";